import api from '@/lib/api';

// Coalesces per-row macro-link lookups into a single bulk request per module.
const pending = new Map(); // key -> { ids:Set, waiters:[], timer }

export function fetchMacroLinks(projectId, microModule, activityId) {
  const key = `${projectId}|${microModule}`;
  let entry = pending.get(key);
  if (!entry) {
    entry = { ids: new Set(), waiters: [], timer: null };
    pending.set(key, entry);
  }
  entry.ids.add(activityId);
  const promise = new Promise((resolve) => entry.waiters.push({ activityId, resolve }));

  if (!entry.timer) {
    entry.timer = setTimeout(async () => {
      pending.delete(key);
      const ids = [...entry.ids];
      let map = {};
      try {
        const { data } = await api.post(
          `/v1/projects/${projectId}/schedule/${microModule}/macro-links/bulk`,
          { activityIds: ids },
        );
        map = data?.links || {};
      } catch { map = {}; }
      entry.waiters.forEach(w => w.resolve(map[w.activityId] || []));
    }, 60);
  }
  return promise;
}
